// Small helper that only logs in non-production builds.
// Keeps debugging signal during development without leaking errors in prod.
const IS_DEV = process.env.NODE_ENV !== "production";

export const logError = (...args) => {
  if (IS_DEV) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
